import React, {Component} from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import {Formik, Field, FieldArray} from 'formik';
import _ from 'lodash';
import config from '../config';
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";

export default class Cohort extends Component {
    static contextType = AuthContext

    constructor(props, context) {
        super(props);
        this.authContext = context;
        let {id} = this.props.match.params;
        this.state = {
            id,
            obj: null
        };
        this.init = this.init.bind(this);
        this.save = this.save.bind(this);
        this.init(id);
    }

    async init(id) {
        let responseCohorts = await fetcher(`${config.API()}collection/user-save-vars`);
        let vars = await responseCohorts.json();
        this.vars = _.sortBy(vars, ['key'])

        if (id == "new") {
            this.state.obj = {
                _id: "new",
                title: ""
            }
        } else {
            let that = this;
            fetcher(`${config.API()}collection/cohorts`)
                .then(response => response.json())
                .then(cohorts => {
                    let obj = _.find(cohorts, x => x._id == id)
                    console.log(this.state, that.state)
                    that.setState({obj})
                });
        }
    }

    async save(values) {
        console.log(values);
        const cleanedValues = _.cloneDeep(values);
        for(let key in cleanedValues){
            if(cleanedValues[key] === ""){
                cleanedValues[key] = null;
            }
        }
        // Очистка conditions от пустых значений
        if (cleanedValues.conditions) {
            cleanedValues.conditions = cleanedValues.conditions.map(condition => {
                return {
                    key: condition.key || null,
                    condition: condition.condition || "equals",
                    value: condition.value || null,
                    min: condition.min || 0,
                    max: condition.max || 0
                };
            });
        }
        var body = JSON.stringify(cleanedValues);
        fetcher(`${config.API()}collection/cohorts/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body
        })
            .then(response => response.json())
            .then(data => {
                this.setState({redirect: `/cohorts`});
            });
    }

    getAvailableConditions(valueType) {
        switch (valueType?.toLowerCase()) {
            case 'string':
                return [
                    { value: 'equals', label: 'Equals' },
                    { value: 'exists', label: 'Exists' }
                ];
            case 'double':
            case 'int':
                return [
                    { value: 'equals', label: 'Equals' },
                    { value: 'greater_than', label: 'Greater Than' },
                    { value: 'less_than', label: 'Less Than' },
                    { value: 'range', label: 'Range' },
                    { value: 'exists', label: 'Exists' }
                ];
            case 'datetime':
                return [
                    { value: 'equals', label: 'Equals' },
                    { value: 'greater_than', label: 'Greater Than' },
                    { value: 'less_than', label: 'Less Than' },
                    { value: 'range', label: 'Range' },
                    { value: 'exists', label: 'Exists' }
                ];
            default:
                return [{ value: 'equals', label: 'Equals' }, { value: 'exists', label: 'Exists' }];
        }
    }

    getInputType(valueType, condition) {
        if (condition === 'exists') return null;
        switch (valueType?.toLowerCase()) {
            case 'double':
            case 'int':
                return 'number';
            case 'datetime':
                return 'datetime-local';
            default:
                return 'text';
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }
        return (
            <div>
                {this.state.obj && <Formik initialValues={this.state.obj} onSubmit={this.save}>
                    {({
                          values,
                          handleSubmit,
                          handleChange,
                          setFieldValue,
                          myHandleChange = evt => {
                              if(evt.target.type == "number" && evt.target.value == "")
                                  evt.target.value = null;
                              handleChange(evt);
                          },
                          isSubmitting
                      }) => (
                        <div className="card shadow w100">
                            <div className="card-header py-3">
                                <h2 className="m-0 font-weight-bold l">Cohort <span className="text-primary">{values.title}</span></h2>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {values._id != "new" && <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Id</label>
                                        <div className="col-sm-10">
                                            {values._id}
                                        </div>
                                    </div>}
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Title</label>
                                        <div className="col-sm-10">
                                            <input className="form-control" type="text" name="title" onChange={myHandleChange} value={values.title}/>
                                        </div>
                                    </div>
                                    {/* Секция для редактирования Conditions */}
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Conditions</label>
                                        <div className="col-sm-10">
                                            <FieldArray name="conditions">
                                                {({ push, remove }) => (
                                                    <div>
                                                        {values.conditions && values.conditions.length > 0 && values.conditions.map((condition, index) => {
                                                            const varItem = this.vars.find(v => v.key === condition.key);
                                                            const availableConditions = this.getAvailableConditions(varItem?.valueType);
                                                            const inputType = this.getInputType(varItem?.valueType, condition.condition);
                                                            const showValue = ['equals', 'greater_than', 'less_than'].includes(condition.condition);
                                                            const showMin = condition.condition === 'range';
                                                            const showMax = condition.condition === 'range';
                                                            return (
                                                                <div key={index} className="card mb-2 p-3">
                                                                    <div className="row">
                                                                        <div className="col-11">
                                                                        <div className="form-group row">
                                                                        <label className="col-sm-2 col-form-label">Key</label>
                                                                        <div className="col-sm-10">
                                                                            <Field
                                                                                as="select"
                                                                                name={`conditions[${index}].key`}
                                                                                className="form-control"
                                                                                onChange={evt => {
                                                                                    setFieldValue(`conditions[${index}].key`, evt.target.value);
                                                                                    // Сбрасываем condition, если оно не поддерживается новым valueType
                                                                                    const newVar = this.vars.find(v => v.key === evt.target.value);
                                                                                    const newConditions = this.getAvailableConditions(newVar?.valueType);
                                                                                    if (!newConditions.find(c => c.value === condition.condition)) {
                                                                                        setFieldValue(`conditions[${index}].condition`, newConditions[0]?.value || 'equals');
                                                                                    }
                                                                                }}
                                                                                value={condition.key || ""}
                                                                            >
                                                                                <option value="">Select a variable</option>
                                                                                {this.vars.map(varItem => (
                                                                                    <option key={varItem.key} value={varItem.key}>
                                                                                        {varItem.key}
                                                                                    </option>
                                                                                ))}
                                                                            </Field>
                                                                        </div>
                                                                    </div>
                                                                        <div className="form-group row">
                                                                        <label className="col-sm-2 col-form-label">Condition</label>
                                                                        <div className="col-sm-10">
                                                                            <Field
                                                                                as="select"
                                                                                name={`conditions[${index}].condition`}
                                                                                className="form-control"
                                                                                onChange={evt => setFieldValue(`conditions[${index}].condition`, evt.target.value)}
                                                                                value={condition.condition || "equals"}
                                                                            >
                                                                                {availableConditions.map(cond => (
                                                                                    <option key={cond.value} value={cond.value}>
                                                                                        {cond.label}
                                                                                    </option>
                                                                                ))}
                                                                            </Field>
                                                                        </div>
                                                                    </div>
                                                                        {showValue && (
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">
                                                                                    {condition.condition === 'greater_than' ? 'Min' : condition.condition === 'less_than' ? 'Max' : 'Value'}
                                                                                </label>
                                                                                <div className="col-sm-10">
                                                                                    <Field
                                                                                        name={`conditions[${index}].value`}
                                                                                        className="form-control"
                                                                                        type={inputType}
                                                                                        onChange={myHandleChange}
                                                                                        value={condition.value || (inputType === 'datetime-local' ? '' : condition.value)}
                                                                                        placeholder={inputType === 'datetime-local' ? 'Select date' : ''}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {showMin && (
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">Min</label>
                                                                                <div className="col-sm-10">
                                                                                    <Field
                                                                                        name={`conditions[${index}].min`}
                                                                                        className="form-control"
                                                                                        type={varItem?.valueType === 'datetime' ? 'datetime-local' : 'number'}
                                                                                        onChange={myHandleChange}
                                                                                        value={varItem?.valueType === 'datetime' ? (condition.min ? new Date(condition.min).toISOString().slice(0, 16) : '') : condition.min || ''}
                                                                                        placeholder={varItem?.valueType === 'datetime' ? 'Select date' : ''}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {showMax && (
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-2 col-form-label">Max</label>
                                                                                <div className="col-sm-10">
                                                                                    <Field
                                                                                        name={`conditions[${index}].max`}
                                                                                        className="form-control"
                                                                                        type={varItem?.valueType === 'datetime' ? 'datetime-local' : 'number'}
                                                                                        onChange={myHandleChange}
                                                                                        value={varItem?.valueType === 'datetime' ? (condition.max ? new Date(condition.max).toISOString().slice(0, 16) : '') : condition.max || ''}
                                                                                        placeholder={varItem?.valueType === 'datetime' ? 'Select date' : ''}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        </div>
                                                                        <div className="col-1">
                                                                            <button type="button" className="btn btn-danger  btn-circle btn-icon ml-1" onClick={() => remove(index)}>
                                                                                <span className="fas fa-fw fa-trash"></span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-icon mb-2"
                                                            onClick={() => push({ key: "", condition: "equals", value: "", min: 0, max: 0 })}
                                                        >
                                                            <span className="fas fa-fw fa-plus"></span> Add Condition
                                                        </button>
                                                    </div>
                                                )}
                                            </FieldArray>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-2 col-form-label">Days was absent</label>
                                        <div className="col-5">
                                            <input type="number" placeholder="Min" name="lastVisitMin" className="form-control" onChange={myHandleChange} value={values.lastVisitMin }/>
                                        </div>
                                        <div className="col-5">
                                            <input type="number" placeholder="Max" name="lastVisitMax" className="form-control" onChange={myHandleChange} value={values.lastVisitMax }/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-2 col-form-label">Days after registration</label>
                                        <div className="col-5">
                                            <input type="number" placeholder="Min" name="daysFromRegistrationMin" className="form-control" onChange={myHandleChange} value={values.daysFromRegistrationMin }/>
                                        </div>
                                        <div className="col-5">
                                            <input type="number" placeholder="Max" name="daysFromRegistrationMax" className="form-control" onChange={myHandleChange} value={values.daysFromRegistrationMax }/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-2 col-form-label">Build Version</label>
                                        <div className="col-5">
                                            <input type="number" placeholder="Min" name="buildVersionMin" className="form-control" onChange={myHandleChange} value={values.buildVersionMin }/>
                                        </div>
                                        <div className="col-5">
                                            <input type="number" placeholder="Max" name="buildVersionMax" className="form-control" onChange={myHandleChange} value={values.buildVersionMax }/>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-icon btn-success ml-1 r"><span className="fas fa-fw fa-save"></span>Save</button>
                                </form>
                            </div>
                        </div>
                    )}
                </Formik>}
            </div>
        );
    }
}